import {
  SEND_RECOVERY_PASSWORD_EMAIL_INIT,
  SEND_RECOVERY_PASSWORD_EMAIL_SUCCESS,
  SEND_RECOVERY_PASSWORD_EMAIL_ERROR,
  SHOW_MODAL_PASSWORD,
  HIDE_MODAL_PASSWORD,
  CLEAR_RESET_PASSWORD_DATA
} from 'actions/forgot-password';
import { sendTemporalCode } from 'services/api/user/password-forgot';
import { getCheckToken } from 'services/api/user/checktoken';
import { getUserInfo as getUserInfoService } from 'services/api/user/getUserInfo';

export const sendRecoveryPasswordEmail = (email,callback) => async dispatch => {
  const sendEmailRequested = () => ({
    type: SEND_RECOVERY_PASSWORD_EMAIL_INIT,
  });

  const sendEmailSucceeded = ({ response }) => ({
    type: SEND_RECOVERY_PASSWORD_EMAIL_SUCCESS,
    response,
  });

  const sendEmailFailed = error => ({
    type: SEND_RECOVERY_PASSWORD_EMAIL_ERROR,
    error,
  });
  dispatch(sendEmailRequested());

  getUserInfoService({},{ email }, null).then((response) => {
    if(response.errors){
      throw(response.errors.code);
    }
    callback && callback(response?.response)
    return sendTemporalCode({ email })
  }).then(async content => {
      if(content.errors){
        throw(content.errors.code);
      }
      dispatch(sendEmailSucceeded({ response: content }))
    })
    .catch(error => dispatch(sendEmailFailed(error)));
};

export const showModalPassword = (token) => dispatch => {
  dispatch({
    type: SHOW_MODAL_PASSWORD,
    token,
  });
};

export const hideModalPassword = () => dispatch => {
  dispatch({
    type: HIDE_MODAL_PASSWORD,
  });
};

export const checkNewToken = (token) => {
  return async dispatch => {
    const checkTokenResponse = getCheckToken(token);
  }
}

export const clearResetPasswordData = () => {
  return {
    type: CLEAR_RESET_PASSWORD_DATA,
  };
};
